import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { TextEntryFormControl } from "../TextEntryFormControl";
import { TextControlStyle } from "../../Utilities/FormDesignConstants";
import { StyledFormHelperText, StyledTextField } from "./CommonStyled";
import { IssueData } from "../../Utilities/ControlRenderContext";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { DateDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/DateDataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";

class XDatePickerEditUI extends React.Component<{ editMe: DatePickerFormControl }> {
    render() {
        return (
            <UISpacedBoxContent>
                {this.props.editMe.renderBaseDataControlEditor()}
                {this.props.editMe.renderTextControlBasePropertyEditor()}
                {this.props.editMe.renderTextStyleSelectionEditor()}
            </UISpacedBoxContent>
        );
    }
}

export class DatePickerFormControl extends TextEntryFormControl {
    readonly __type: string = "Date Picker";

    formatDate(date: Date) {
        let d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
    }

    render() {
        let style = this.getFormContext()?.form?.defaultTextStyle;

        if (this.overrideStyle && this.style) style = this.style;

        let size: "medium" | "small" = this.getFormContext()?.form?.defaultTextSize ?? "medium";

        if (this.overrideStyle && this.size) size = this.size;

        const issueData: IssueData | null = this.getFormContext()!.getControlContext(this)!.getRuntimeIssueData();
        const issueText: string = issueData?.text || "";
        const customWidth = this.fullWidth ? "100%" : this.width ? `${this.width}px` : "200px";

        switch (style) {
            case TextControlStyle.LABELED:
                return (
                    <form noValidate>
                        {this.label && <UILabel variant={"form_label"}>{this.label}</UILabel>}
                        <StyledTextField
                            size={size}
                            data-size={size}
                            variant={"outlined"}
                            type="date"
                            fullWidth={this.fullWidth}
                            value={this.valueName ? this.getFormDataValue(this.valueName) : this.formatDate(new Date())}
                            onChange={this.handleChange}
                            data-testid={this.valueName}
                            width={customWidth}
                            error={Boolean(issueText)}
                            InputProps={{
                                inputRef: this.ref,
                            }}
                        />
                        {issueText && issueText.length > 30 && (
                            <Tooltip
                                title={issueText}
                                arrow
                                placement="bottom"
                            >
                                <StyledFormHelperText
                                    error={Boolean(issueText)}
                                    data-testid={`${this.valueName || "datepicker"}-hinttext`}
                                >
                                    {issueText.slice(0, 30) + "..."}
                                </StyledFormHelperText>
                            </Tooltip>
                        )}
                        {((issueText && issueText.length < 31) || this.hintText) && (
                            <StyledFormHelperText
                                error={Boolean(issueText)}
                                data-testid={`${this.valueName || "datepicker"}-hinttext`}
                            >
                                {issueText ? issueText : this.hintText}
                            </StyledFormHelperText>
                        )}
                    </form>
                );
            case TextControlStyle.SHADED:
                return (
                    <form noValidate>
                        <StyledTextField
                            size={size}
                            data-size={size}
                            variant={"filled"}
                            customstyle={"filled"}
                            type="date"
                            fullWidth={this.fullWidth}
                            value={this.valueName ? this.getFormDataValue(this.valueName) : this.formatDate(new Date())}
                            onChange={this.handleChange}
                            data-testid={this.valueName}
                            width={customWidth}
                            error={Boolean(issueText)}
                            label={this.label}
                            InputProps={{
                                inputRef: this.ref,
                            }}
                        />
                        {issueText && issueText.length > 30 && (
                            <Tooltip
                                title={issueText}
                                arrow
                                placement="bottom"
                            >
                                <StyledFormHelperText
                                    error={Boolean(issueText)}
                                    data-testid={`${this.valueName || "datepicker"}-hinttext`}
                                >
                                    {issueText.slice(0, 30) + "..."}
                                </StyledFormHelperText>
                            </Tooltip>
                        )}
                        {((issueText && issueText.length < 31) || this.hintText) && (
                            <StyledFormHelperText
                                error={Boolean(issueText)}
                                data-testid={`${this.valueName || "datepicker"}-hinttext`}
                            >
                                {issueText ? issueText : this.hintText}
                            </StyledFormHelperText>
                        )}
                    </form>
                );
            case TextControlStyle.UNDERLINED:
                return (
                    <form noValidate>
                        <StyledTextField
                            size={size}
                            data-size={size}
                            variant={"standard"}
                            customstyle={"standard"}
                            type="date"
                            fullWidth={this.fullWidth}
                            value={this.valueName ? this.getFormDataValue(this.valueName) : this.formatDate(new Date())}
                            onChange={this.handleChange}
                            data-testid={this.valueName}
                            width={customWidth}
                            error={Boolean(issueText)}
                            label={this.label}
                            ispicker={"true"}
                            InputProps={{
                                inputRef: this.ref,
                            }}
                        />
                        {issueText && issueText.length > 30 && (
                            <Tooltip
                                title={issueText}
                                arrow
                                placement="bottom"
                            >
                                <StyledFormHelperText
                                    error={Boolean(issueText)}
                                    data-testid={`${this.valueName || "datepicker"}-hinttext`}
                                >
                                    {issueText.slice(0, 30) + "..."}
                                </StyledFormHelperText>
                            </Tooltip>
                        )}
                        {((issueText && issueText.length < 31) || this.hintText) && (
                            <StyledFormHelperText
                                error={Boolean(issueText)}
                                data-testid={`${this.valueName || "datepicker"}-hinttext`}
                            >
                                {issueText ? issueText : this.hintText}
                            </StyledFormHelperText>
                        )}
                    </form>
                );
            case TextControlStyle.OUTLINE:
                return (
                    <form noValidate>
                        <StyledTextField
                            size={size}
                            data-size={size}
                            variant={"outlined"}
                            customstyle={"outlined"}
                            type="date"
                            fullWidth={this.fullWidth}
                            value={this.valueName ? this.getFormDataValue(this.valueName) : this.formatDate(new Date())}
                            onChange={this.handleChange}
                            data-testid={this.valueName}
                            width={customWidth}
                            error={Boolean(issueText)}
                            label={this.label}
                            ispicker={"true"}
                            InputProps={{
                                inputRef: this.ref,
                            }}
                        />
                        {issueText && issueText.length > 30 && (
                            <Tooltip
                                title={issueText}
                                arrow
                                placement="bottom"
                            >
                                <StyledFormHelperText
                                    error={Boolean(issueText)}
                                    data-testid={`${this.valueName || "datepicker"}-hinttext`}
                                >
                                    {issueText.slice(0, 30) + "..."}
                                </StyledFormHelperText>
                            </Tooltip>
                        )}
                        {((issueText && issueText.length < 31) || this.hintText) && (
                            <StyledFormHelperText
                                error={Boolean(issueText)}
                                data-testid={`${this.valueName || "datepicker"}-hinttext`}
                            >
                                {issueText ? issueText : this.hintText}
                            </StyledFormHelperText>
                        )}
                    </form>
                );
        }
    }

    renderEditUI(): JSX.Element | null {
        return <XDatePickerEditUI editMe={this} />;
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        if (!this.valueName) return;

        let def = new DateDataDefinition();
        def.name = this.valueName;
        return def;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "", "", "", "", "");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "", "", "", "", "");
    }

    private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        //        console.log(event.currentTarget.value);
        if (this.valueName) {
            this.setFormDataValue(this.valueName, event.currentTarget.value);
        }
    };
}
